import { Mail, MessageCircle } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="scroll-mt-20">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28 lg:px-8 lg:py-36">
        <Reveal>
          <ChapterTag number="04" label="Contact Me" />
          <h2 className="mt-4 font-display text-2xl font-bold leading-snug tracking-tight text-[#1C1B1A] sm:text-3xl lg:text-4xl">
            Let&apos;s talk about your trading journey
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-[#524E48] sm:text-lg">
            Whether you are just starting out or looking to bring more structure
            to your options trading, I would be glad to hear from you.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
            <a
              data-testid="contact-email-link"
              href={`mailto:saathtrainings@gmail.com?subject=${encodeURIComponent("Trading Mentorship Enquiry — SAATH Trainings")}&body=${encodeURIComponent("Hi Husain,\n\nI'd like to know more about your options trading mentorship and how you can help me build a more structured approach.\n\nA little about me:\n- My experience level: \n- What I'm looking for: \n\nLooking forward to hearing from you.\n\nThanks")}`}
              className="group flex min-h-[120px] flex-col justify-center gap-3 rounded-2xl border border-[#E2D9CC] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#E05A10]/60 hover:shadow-[0_24px_50px_-20px_rgba(224,90,16,0.25)] sm:p-8"
            >
              <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#8C857B]">
                <Mail size={15} className="text-[#E05A10]" /> Email
              </span>
              <span className="link-underline w-fit break-all font-display text-lg font-semibold text-[#1C1B1A] sm:text-2xl">
                saathtrainings@gmail.com
              </span>
            </a>

            <div className="flex min-h-[120px] flex-col justify-center gap-3 rounded-2xl border border-[#E2D9CC] bg-[#1C1B1A] p-7 sm:p-8">
              <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#8C857B]">
                <MessageCircle size={15} className="text-[#E05A10]" /> WhatsApp
              </span>
              <a
                data-testid="contact-whatsapp-button"
                href={`https://wa.me/917897520926?text=${encodeURIComponent("Hi SAATH, I'd like to know about your trainings")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-[52px] w-fit items-center gap-2 rounded-full bg-[#E05A10] px-6 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#B43B00] active:scale-[0.97] sm:text-base"
              >
                <MessageCircle size={18} />
                Chat with me on WhatsApp
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
